import { Linking, Platform } from 'react-native'

export const openUrl = (url: string, isNewTab: boolean = false) => {
  if (Platform.OS === 'web') window.open(url, isNewTab ? '_blank' : '_self')
  else Linking.openURL('https://app.mycabana.health/') //TODO add https on android manifest [When targeting Android 11 (SDK 30)]
}
